import filterDeep from 'deepdash/filterDeep';
import isEqual from 'lodash/isEqual';

/**
 * Given two values, return whether they are not the same.
 * See docs for acceptable values: https://lodash.com/docs/4.17.15#isEqual
 */
export const getNodeEditorHasChanges = (initialNodeData: unknown, currentNodeData: unknown) => {
  return !isEqual(initialNodeData, currentNodeData);
};

/**
 * Removes empty values deep
 * Note: this does not include empty arrays or objects
 *
 * @see https://deepdash.io/#filterdeep
 * @param { Object } data
 * @returns new object with empty values omitted
 */
export const removeEmptyDeep = (data: unknown, options?: object) =>
  filterDeep(
    data,
    (value) => {
      // Can't use `!value` here as that'd remove `false`
      if (value === null || value === undefined || value === '') {
        return false;
      }

      return true;
    },
    options,
  );
